module.exports = __WEBPACK_EXTERNAL_MODULE__powersync_common__;